import React from "react";
import { motion } from "framer-motion";
import bingopayLogo from "../Assets/Images/logoBingo.png"

const Loading = ({ isOpen }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                <img src={bingopayLogo} alt="bingopay Logo" className="h-8 mb-4" />
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ repeat: Infinity, duration: 1 }}
                    className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full"
                ></motion.div>
                <p className="mt-4 text-gray-700">Processing Payment...</p>
                <p className="mt-2 text-red-500 font-semibold">
                    ⚠️ Don't press the back button or refresh!
                </p>
            </div>
        </div>
    );
};

export default Loading;
 